import React, { useState } from "react";
import styled, { css } from "styled-components";
import { Colors, Text } from "../../config";
import dayjs from "dayjs";

const arrowDownCircle = require("../../assets/images/Arrow-DownCircle.png");
const bgActive = require("../../assets/images/img_ticketbg_active.png");
const bgInactive = require("../../assets/images/img_ticketbg_inactive.png");

const ValidityAccordion = ({ eachPassenger }) => {
  const {
    firstName: passengerFirstName,
    lastName: passengerLastName,
    relation: passengerRelation,
    ticketEncash: passengerTicketCount,
    entitlement: passengerEntitlement,
  } = eachPassenger;

  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const notSelf = passengerRelation !== "Self";
  const isTicketGreaterThan = passengerTicketCount >= 1;

  // const earliestExpiry = passengerTicketCount > 0 && passengerTickets[0]["validTill"];
  const ticketOrTickets = passengerTicketCount < 2 ? " TICKET" : " TICKETS";

  const handleClick = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  const getEarliestExpiry = (entitlement) => {
    let sorted = entitlement.sort(function (a, b) {
      let time1 = new Date(a.expiryDate);
      let time2 = new Date(b.expiryDate);
      return time1.getTime() - time2.getTime();
    });
    return sorted[0]?.expiryDate
      ? dayjs(sorted[0].expiryDate).format("DD/MM/YYYY")
      : " -";
  };

  return (
    <div>
      <EachPassengerName>
        {passengerFirstName + " " + passengerLastName}
        {notSelf && <span> ({passengerRelation})</span>}
      </EachPassengerName>
      <AccordionFull>
        <AccordionContainer
          onClick={isTicketGreaterThan ? handleClick : undefined}
          isTicketGreaterThan={isTicketGreaterThan}
        >
          <NumOfTickets>
            <span>{Math.floor(passengerTicketCount)}</span>
            {ticketOrTickets}
          </NumOfTickets>
          {isTicketGreaterThan ? (
            <ExpiryArrowWrapper>
              <ExpiryText>
                {Text.earliestExpiry}
                {getEarliestExpiry(passengerEntitlement)}
              </ExpiryText>
              <ArrowImage
                src={arrowDownCircle}
                alt="view"
                isAccordionOpen={isAccordionOpen}
              />
            </ExpiryArrowWrapper>
          ) : (
            <NoTicketWrapper>
              <ExpiryText>{Text.noTicketsAvailable}</ExpiryText>
              <SelfPaid>{Text.pleaseBookSelfPaid}</SelfPaid>
            </NoTicketWrapper>
          )}
        </AccordionContainer>
        {isTicketGreaterThan && (
          <AccordionContent isAccordionOpen={isAccordionOpen}>
            {passengerEntitlement?.map((eachTicket, i) => {
              return (
                <AccordionContentWrapper key={i}>
                  <TicketIssuedOn>
                    {Text.ticketIssuedOn}
                    {eachTicket?.startDate
                      ? dayjs(eachTicket.startDate).format("YYYY")
                      : "-"}
                  </TicketIssuedOn>
                  <ValidTill>
                    {Text.validTill}
                    {eachTicket?.expiryDate
                      ? dayjs(eachTicket.expiryDate).format("DD/MM/YYYY")
                      : "-"}
                  </ValidTill>
                </AccordionContentWrapper>
              );
            })}
          </AccordionContent>
        )}
      </AccordionFull>
    </div>
  );
};

export default ValidityAccordion;

const AccordionFull = styled.div`
  background: ${Colors.brandOne};
  border-radius: 0.625rem;
  display: flex;
  flex-direction: column;
  margin-top: 1.25rem;
  @media only screen and (min-width: 1440px) {
    width: 31.75rem;
  }
  @media only screen and (max-width: 1440px) {
    width: 100%;
    max-width: 31.75rem;
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
  }
`;
const AccordionContainer = styled.div`
  padding: 0.75rem 1.25rem;
  background: ${(props) =>
    props.isTicketGreaterThan ? `url(${bgActive})` : `url(${bgInactive})`};
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 0.625rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  cursor: ${(props) => (props.isTicketGreaterThan ? "pointer" : "not-allowed")};
  @media only screen and (max-width: 1140px) {
    padding: 0.75rem 0.5rem 0.75rem 1rem;
  }
`;
const ExpiryArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  @media only screen and (max-width: 1140px) {
    gap: 1rem;
  }
`;
const ExpiryText = styled.div`
  font-weight: 400;
  font-size: 1rem;
  color: ${Colors.white};
  text-align: right;
  @media only screen and (max-width: 1140px) {
    font-size: 0.75rem;
  }
`;
const NumOfTickets = styled.div`
  > span {
    font-size: 2rem;
  }
  font-size: 1rem;
  font-weight: 700;
  color: ${Colors.white};
  @media only screen and (max-width: 1140px) {
    font-size: 0.875rem;
  }
`;
const EachPassengerName = styled.div`
  font-weight: 600;
  font-size: 1.125rem;
  color: ${Colors.brandTwo};
  > span {
    color: ${Colors.white};
    text-transform: title-case;
  }
`;
const AccordionContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const AccordionContent = styled.div`
  display: ${(props) => (props.isAccordionOpen ? "flex" : "none")};
  padding: 1.125rem 4.8rem 1.125rem 1.25rem;
  flex-direction: column;
  gap: 0.625rem;
  @media only screen and (max-width: 1140px) {
    padding-right: 3rem;
  }
`;
const TicketIssuedOn = styled.div`
  font-weight: 400;
  font-size: 0.875rem;
  color: ${Colors.brandTwo};
  width: 50%;
  @media only screen and (max-width: 1140px) {
    font-size: 0.75rem;
  }
`;
const ValidTill = styled.div`
  font-weight: 400;
  font-size: 0.875rem;
  color: ${Colors.white};
  text-align: right;
  width: 50%;
  @media only screen and (max-width: 1140px) {
    font-size: 0.75rem;
  }
`;
const ArrowImage = styled.img`
  transition: transform 0.2s ease-in;
  ${(props) =>
    props.isAccordionOpen &&
    css`
      transform: rotate(180deg);
    `}
`;
const NoTicketWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 3.6rem;
  @media only screen and (max-width: 1140px) {
    padding-right: 2.5rem;
  }
`;
const SelfPaid = styled.div`
  font-weight: 500;
  font-size: 0.75rem;
  color: ${Colors.brandOne};
  text-align: right;
  @media only screen and (max-width: 1140px) {
    font-size: 0.625rem;
  }
`;
